import type { QuoteRequestStatus, QuoteRow } from '@repo/api-contracts';

/**
 * 고객 화면 상태 이름(견적 설계 §4-1).
 *
 * 주문됨(ORDERED)은 주문 고객 화면 이름(주문 설계 §4-3 — 결제 대기·제작 중·배송 중·환불 완료 등)을 따른다(`quoteStatusLabel`).
 * 여기의 '주문 진행 중'은 살아 있는 주문을 읽지 못했을 때(`orderDisplayStatus` null)만 쓰는 대체 이름이다.
 */
export const QUOTE_STATUS_LABELS: Readonly<Record<QuoteRequestStatus, string>> = {
  REQUESTED: '검토 중',
  ISSUED: '견적 도착',
  REVISION_REQUESTED: '수정 요청됨',
  ORDERED: '주문 진행 중',
  DECLINED: '거절함',
  REJECTED: '반려됨',
  CANCELED: '요청 취소',
  EXPIRED: '만료',
};

/**
 * 내 견적 목록·상세의 상태 이름 — 주문된 견적은 서버(주문 모듈)가 계산한 주문 고객 화면 이름을 그대로 쓴다(주문 설계 §8-4,
 * 내 주문·내 견적·ADMIN 목록이 같은 이름). 그 밖의 견적은 견적 상태 이름이다.
 */
export const quoteStatusLabel = (row: Pick<QuoteRow, 'status' | 'orderDisplayStatus'>): string =>
  row.status === 'ORDERED' && row.orderDisplayStatus !== null
    ? row.orderDisplayStatus
    : QUOTE_STATUS_LABELS[row.status];
